import React from 'react';
import styled from 'styled-components';

import { ProductContextProvider } from '@/providers/Product';

import Header from './components/Header';
import Gallery from './components/Gallery';
import Main from './components/Main';
import Footer from './components/Footer';

function Product() {
  return (
    <Component>
      <Header />
      <Gallery />
      <ProductContextProvider>
        <Main />
      </ProductContextProvider>
      <Footer />
    </Component>
  );
}

export default Product;

const Component = styled.div``;
